/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

/*global TE_CONFIG, jQuery, $ */

import 'global-jquery.js';

import 'jquery-ui-bundle';
import { Foundation } from 'foundation-sites/js/foundation.core';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { Motion } from 'foundation-sites/js/foundation.util.motion';
import { Timer } from 'foundation-sites/js/foundation.util.timer';
import { Touch } from 'foundation-sites/js/foundation.util.touch';

import { Equalizer } from 'foundation-sites/js/foundation.equalizer';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { Sticky } from 'foundation-sites/js/foundation.sticky';
import { Orbit } from 'foundation-sites/js/foundation.orbit';

import 'lightbox2/dist/js/lightbox.js';

Foundation.addToJquery($);

Foundation.plugin(MediaQuery, 'MediaQuery');
Foundation.plugin(onImagesLoaded, 'ImageLoader');
Foundation.plugin(Keyboard, 'Keyboard');
Foundation.plugin(Motion, 'Motion');
Foundation.plugin(Timer, 'Timer');
Foundation.plugin(Touch, 'Touch');

Foundation.plugin(Equalizer, 'Equalizer');
Foundation.plugin(OffCanvas, 'OffCanvas');
Foundation.plugin(Sticky, 'Sticky');
Foundation.plugin(Orbit, 'Orbit');

(function($) {
	var App = {
		common: function() {
			$(document).foundation();

            $( '.date-picker' ).datepicker({
              minDate: 1,
              dateFormat: 'dd/mm/yy'
            });

            App.mobile_menu.init();

            $( window ).resize(function() {
                App.mobile_menu.init();
            });

            $('#booking_form').submit(function(e) {
                e.preventDefault();
                App.form_submit($(this));
            });

            $('.quick-nav').on('change', function() {
                window.location.href = $(this).val();
            });

						App.gift_voucher_form.adult();
						App.gift_voucher_form.child();
						App.gift_voucher_form.arrive_and_play();
						App.gift_voucher_form.tournament();

						$('.adult-gift-voucher-container input, .adult-gift-voucher-container select, .adult-gift-voucher-container textarea').on('change', function () {
							App.gift_voucher_form.adult();
						});

						$('.child-gift-voucher-container input, .child-gift-voucher-container select, .child-gift-voucher-container textarea').on('change', function () {
							App.gift_voucher_form.child();
						});

						$('.arrive-and-play-gift-voucher-container input, .arrive-and-play-gift-voucher-container select, .arrive-and-play-gift-voucher-container textarea').on('change', function () {
							App.gift_voucher_form.arrive_and_play();
						});

						$('.tournament-gift-voucher-container input, .tournament-gift-voucher-container select, .tournament-gift-voucher-container textarea').on('change', function () {
							App.gift_voucher_form.tournament();
						});
		},
			gift_voucher_form: {
				adult: function () {
					var form = $('.adult-gift-voucher-container form'),
					players = form.find('.group_size').find(":selected").val(),
					base_price = form.find('.location').find(":selected").attr('data-voucher-price'),
					location = form.find('.location').val(),
					event_type = form.find('select[name="event_type"]').val(),
					event_date = form.find('.date-picker').val(),
					start_time = form.find('select[name="start_time"]').val(),
					amount = players * base_price;

					form.find('.amount').val(amount);
					form.find('.total-label').text('£' + amount);
					form.find('input[name="desc"]').val('Adult Gift Voucher - ' + event_type + ' - ' + players + ' Players - ' + location + ' - ' + event_date + ' - ' + start_time + ' - £' + amount );

				},

				child: function () {
					var form = $('.child-gift-voucher-container form'),
					players = form.find('.group_size').find(":selected").val(),
					age_range = form.find('[name="age-range"]').find(":selected").val(),
					price_type = form.find('.location').find(":selected").attr('data-kids-pricing'),
					location = form.find('.location').val(),
					event_type = form.find('select[name="event_type"]').val(),
					event_date = form.find('.date-picker').val(),
					start_time = form.find('select[name="start_time"]').val(),
					amount = form.find('.group_size').find(":selected").attr('data-' + price_type + '-price');

					form.find('.amount').val(amount);
					form.find('.total-label').text('£' + amount);
					form.find('input[name="desc"]').val('Child Gift Voucher - ' + event_type + ' - ' + players + age_range + ' - ' + location + ' - ' + event_date + ' - ' + start_time + ' - £' + amount );

				},
				arrive_and_play: function () {
					var form = $('.arrive-and-play-gift-voucher-container form'),
					adults_players = form.find('.group_size_adults').find(":selected").val(),
					junior_players = form.find('.group_size_juniors').find(":selected").val(),
					base_price = form.find('.location').find(":selected").attr('data-adult-voucher-price'),
					junior_price = form.find('.location').find(":selected").attr('data-junior-voucher-price'),
					location = form.find('.location').val(),
					event_type = form.find('select[name="event_type"]').val(),
					event_date = form.find('.date-picker').val(),
					start_time = form.find('select[name="start_time"]').val(),
					amount = (adults_players * base_price) + (junior_players * junior_price),
					name = form.find('.recipient').val(),
					added_message = form.find('.message').val(),
					string = 'Arrive and Play Voucher';

					if( adults_players ) {
						string = string + ' - Adults: ' + adults_players;
					}
					if( junior_players ) {
						string = string + ' - Juniors: ' + junior_players;
					}

					if( location ) {
						string = string + ' - Location: ' + location;
					}
					if( event_type ) {
						string = string + ' - Event Type: ' + event_type;
					}
					if( event_date ) {
						string = string + ' - Event Date: ' + event_date;
					}
					if( start_time ) {
						string = string + ' - Start Time: ' + start_time;
					}
					if( amount ) {
						string = string + ' - Amount: ' + amount;
					}
					if( name ) {
						string = string + ' - Recipient Name: ' + name;
					}
					if( added_message ) {
						string = string + ' - Message: ' + added_message;
					}

					form.find('#MC_recipient_name').val(name);
					form.find('#MC_adult_players').val(adults_players);
					form.find('#MC_junior_players').val(junior_players);
					form.find('#MC_location').val(location);
					form.find('#MC_event_type').val(event_type);
					form.find('#MC_event_date').val(event_date);
					form.find('#MC_start_time').val(start_time);
					form.find('#MC_amount').val(amount);
					form.find('#MC_message').val(added_message);

					form.find('.amount').val(amount);
					form.find('.total-label').text('£' + amount);
					form.find('input[name="desc"]').val(string);

				},
				tournament: function () {
					var form = $('.tournament-gift-voucher-container form'),
					players = form.find('.group_size').find(":selected").val(),
					adult_price = form.find('.location').find(":selected").attr('data-adult-voucher-price'),
					child_price = form.find('.location').find(":selected").attr('data-child-voucher-price'),
					age_range = form.find('[name="age-range"]').find(":selected").val(),
					location = form.find('.location').val(),
					event_type = form.find('select[name="event_type"]').val(),
					event_date = form.find('.date-picker').val(),
					start_time = form.find('select[name="start_time"]').val(),
					amount = players * adult_price,
					name = form.find('.recipient').val(),
					added_message = form.find('.message').val(),
					string = 'Tournament Gift Voucher';

					if( age_range == 'Adults') {
						amount = players * adult_price;
					} else {
						amount = players * child_price;
					}

					form.find('.amount').val(amount);
					form.find('.total-label').text('£' + amount);

					if( players ) {
						string = string + ' - Players: ' + players;
					}
					if( adult_price ) {
						string = string + ' - Adult Price: ' + adult_price;
					}
					if( child_price ) {
						string = string + ' - Child Price: ' + child_price;
					}
					if( age_range ) {
						string = string + ' - Age Range: ' + age_range;
					}
					if( location ) {
						string = string + ' - Location: ' + location;
					}
					if( event_type ) {
						string = string + ' - Event Type: ' + event_type;
					}
					if( event_date ) {
						string = string + ' - Event Date: ' + event_date;
					}
					if( start_time ) {
						string = string + ' - Start Time: ' + start_time;
					}
					if( amount ) {
						string = string + ' - Amount: ' + amount;
					}
					if( name ) {
						string = string + ' - Recipient Name: ' + name;
					}
					if( added_message ) {
						string = string + ' - Message: ' + added_message;
					}

					form.find('input[name="desc"]').val(string);

				},
			},

        form_submit: function(booking_form) {
            var form_fields = {};

            booking_form.addClass('loading');
            booking_form.find('.form-field').each(function() {
							if( $(this).attr('type') == 'checkbox'){
								if( $(this).prop('checked') ) {
										form_fields[$(this).attr('name')] = $(this).val();
								}
							} else {
								form_fields[$(this).attr('name')] = $(this).val();
							}
            });

						console.log(TE_CONFIG.nonce);

            $.ajax({
                url: booking_form.attr('action'),
                method: 'POST',
                type: 'POST',
                data: form_fields,
                crossDomain: true,
                async: true,
                success: function(success) {
                    if(success.hasOwnProperty('success')) {
                        window.location.href = booking_form.attr('data-success-redirect');
                    } else {
                        window.location.href = booking_form.attr('data-error-redirect');
                    }
                },
                fail: function() {
                    window.location.href = booking_form.attr('data-error-redirect');
                }
            }).always(function(){
                booking_form.removeClass('loading');
            });

            return false;
        },

        mobile_menu: {
            init: function () {
                var currentMediaQuery = Foundation.MediaQuery.current;

                if ( currentMediaQuery == 'medium' || currentMediaQuery == 'small' ) {
                    this.mobileMenu();
                    this.videoMobileHeader();
                } else {
                    this.desktopMenu();
                    this.videoDesktopHeader();
                }
            },

            mobileMenu: function () {
                if( $('.mobile-menu-container .header-content').length ) {
                    return false;
                }

                $('.header-content').appendTo('.mobile-menu-container');

                $('.mobile-menu-container .menu-item-has-children > a').on('click', function(e) {
                    e.preventDefault();
                    $(this).parent('.menu-item-has-children').toggleClass('show-children');
                });
            },

            desktopMenu: function () {
                if( !$('.mobile-menu-container .header-content').length ) {
                    return false;
                }

                $('.header-content').appendTo('.menu-container');
            },


            videoMobileHeader: function () {
                $('.event-type-video-container').prependTo('main');
                $('.location-video-container').prependTo('main');
                $('.activities-video-container').prependTo('main');
                $('.team-building-video-container').prependTo('main');
            },

            videoDesktopHeader: function () {
                $('.event-type-video-container').appendTo('.second-column');
                $('.location-video-container').appendTo('.second-column');
                $('.activities-video-container').appendTo('.second-column');
                $('.team-building-video-container').appendTo('.second-column');
            }
        }
    };

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Router = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				App.common();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
        'page_id_646': {
            init: function() {
                setTimeout( function() {
                  window.location.href = document.location.origin;
                }, 5000);
            }
        }
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Router;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
